import { signInWithRedirect } from "aws-amplify/auth";

import { APP_V2_APP_EVENTS, logEvent } from "../../lib/analytics";

export const RIPPLING_SSO_REQUESTED_URL_KEY = "rippling_sso_requested_url";

/**
 * Starts the Rippling SSO redirect flow. Called from the login form when
 * the email matches a non-aliased Clipboard Health employee pattern, and
 * from the SSO callback when retrying after account linking or IdP-initiated flows.
 */
export async function startSsoRedirect(requestedUrl?: string): Promise<void> {
  logEvent(APP_V2_APP_EVENTS.RIPPLING_SSO_STARTED);

  const isLoginPath =
    !requestedUrl || requestedUrl === "/enter" || requestedUrl === "/login" || requestedUrl === "/";
  if (!isLoginPath) {
    localStorage.setItem(RIPPLING_SSO_REQUESTED_URL_KEY, requestedUrl);
  } else {
    localStorage.removeItem(RIPPLING_SSO_REQUESTED_URL_KEY);
  }

  await signInWithRedirect({
    provider: { custom: "RipplingEmployees" },
    options: { prompt: "LOGIN" },
  });
}
